/**
 * @author 胡小右
 * @date 2023-04-24 14:36:19
 * @desc AES加密解密
 */
import CryptoJS from 'crypto-js';

export default class Encryption {
    private static key = CryptoJS.enc.Utf8.parse('mMlEeONhiat2TFbwIqWd4c5kvQ1JxLsK'); // 密钥

    // 加密方法
    public static encrypt(text: string): string {
        const decryptedData = CryptoJS.AES.encrypt(text, this.key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7,
        });
        return decryptedData.toString();
    }

    // 解密方法
    public static decrypt(text: string): string {
        // 对Base64数据进行解密
        const decryptedData = CryptoJS.AES.decrypt(text, this.key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7,
        });

        // 将解密后的数据从WordArray对象转换为Utf8字符串
        return CryptoJS.enc.Utf8.stringify(decryptedData);
        // return decrypted.toString(enc.Utf8);
    }
}
